/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useAppDispatch} from "../../../../../redux/hooks";
import useGetUrlParams from "../../../../../hooks/useGetUrlParams";
import {StringParam, useQueryParam} from "use-query-params";
import * as React from "react";
import {usePostRequest} from "../../../../../api/helper";
import {VEHICLE_PROGRAMS_CONSTANTS} from "../../constants";
import {toast} from "react-hot-toast";
import {setDevelopmentStagesTree, setVehicleProgramsSelectedDevelopmentStageData} from "../../../../../redux/ducks/VehicleProgramsDetails/slice";
import ArgosContextMenu from "../../../../components/ContextMenu/ArgosContextMenu";
import {ArgosContextMenuListItem} from "../../../../components/Tree/Parts/JamaTreeContainer";
import {IconButton} from "@mui/material";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import ArgosDialog from "../../../../components/Dialogs/ArgosDialog";
import BoxWithCenteredContent from "../../../../components/Containers/BoxWithCenteredContent";
import ArgosFlexbox from "../../../../components/Containers/ArgosFlexbox";
import ArgosButton, {ArgosLoadingButton} from "../../../../components/Buttons/ArgosButton";
import AddAdasProgramDialog from "./AddAdasProgramDialog";
import {useGetCurrentPageUserAccessLevel} from "../../../../../redux/ducks/AccessControl/accessControlHelpers";
import {EUserPermissionAccess} from "../../../../../redux/ducks/AccessControl/types";

const deleteDevStageMenuItemLabel = 'Delete'
const linkAdasProgramMenuItemLabel = 'Link ADAS Program'

const ContextMenu = (props: any) => {
  const {addAdasProgramDialogData, setAddAdasProgramDialogData} = props;
  const dispatch = useAppDispatch()
  const {isRightClickMenuOpen, setIsRightClickMenuOpen, menuPosition, rightClickNodeData} = props
  const {vehicleProgramId} = useGetUrlParams()
  const [developmentStageId, setDevelopmentStageId] = useQueryParam('developmentStageId', StringParam)
  const wrapperRef = React.useRef(null);

  /**
   * Access control
   */
  const [isUserAdmin, userAccessLevel] = useGetCurrentPageUserAccessLevel()

  const deleteDevelopmentStageHandle = usePostRequest(VEHICLE_PROGRAMS_CONSTANTS.itemDetails.endpoints.deleteDevelopmentStageData)
  const deleteDevelopmentStage = () => {
    const nodeIdToDelete = rightClickNodeData?.nodeId
    if (!vehicleProgramId || !nodeIdToDelete) {
      toast.error("Invalid node data, can't delete")
      return
    }
    setIsDeletingReport(true)
    const _developmentStageId = rightClickNodeData?.developmentStageId
    const _adasProgramId = rightClickNodeData?.adasProgramId
    deleteDevelopmentStageHandle({vehicleProgramId, adasProgramId: _adasProgramId, developmentStageId: _developmentStageId})
      .then((res: any) => {
        setIsRightClickMenuOpen(false)
        const _tree = res?.tree
        if (_tree) {
          dispatch(setDevelopmentStagesTree(_tree))
        }
        setVehicleProgramsSelectedDevelopmentStageData(null)
        setDevelopmentStageId(undefined)
        setDeleteDialogData(null)
      })
      .catch((err: any) => {
        toast.error('Error deleting development stage')
        console.log('error', err)
      })
      .finally(() => {
        setIsDeletingReport(false)
      })
  }

  const [deleteDialogData, setDeleteDialogData] = React.useState<any>(null)
  const [isDeletingReport, setIsDeletingReport] = React.useState(false)

  const noMenuItemsAdasPrograms = !isUserAdmin && (!rightClickNodeData?.type || rightClickNodeData?.type === 'adasProgram')
  const noMenuItemsDevStage = !isUserAdmin && rightClickNodeData?.type === 'devStageFolder' && (!isUserAdmin && userAccessLevel === EUserPermissionAccess.READ_ONLY)
  const dontShowMenu = noMenuItemsAdasPrograms || noMenuItemsDevStage
  return (
    <>
      {
        isRightClickMenuOpen && !dontShowMenu &&
        <ArgosContextMenu
          ref={wrapperRef}
          open={isRightClickMenuOpen}
          top={menuPosition?.y ? menuPosition.y - 30 : undefined}
          left={menuPosition?.x ? menuPosition.x + 30 : undefined}
        >
          {rightClickNodeData.type === 'devStageFolder' &&
            <ul>
              {/* Add ADAS Program */}
              <ArgosContextMenuListItem
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setAddAdasProgramDialogData(true)
                  setIsRightClickMenuOpen(false)
                }}
              >
                {linkAdasProgramMenuItemLabel}
              </ArgosContextMenuListItem>
            </ul>
          }
          <ul>
            {/* Delete */}
            <ArgosContextMenuListItem
              onClick={(e) => {
                setDeleteDialogData(true)
              }}
              style={{display: isUserAdmin ? 'block' : 'none'}}
            >
              {deleteDevStageMenuItemLabel}
            </ArgosContextMenuListItem>
          </ul>
          <IconButton
            style={{justifyContent: "right", color: "white"}}
            onClick={e => setIsRightClickMenuOpen(false)}
          >
            <DisabledByDefaultIcon/>
          </IconButton>

          {/*Delete Dialog*/}
          <ArgosDialog
            width={'auto'} height={'auto'}
            open={deleteDialogData != null}
            onClose={() => setDeleteDialogData(null)}
            headerTitle={`Delete Development Stage`}
            headerTitleAlign={'left'}
          >
            <BoxWithCenteredContent horizontal vertical
                                    style={{height: '100%', display: 'flex', flexFlow: 'column nowrap'}}>
              <p style={{width: '300px', textAlign: 'center'}}>
                Are you sure you want to delete? This cannot be undone.
              </p>
              <ArgosFlexbox>
                <ArgosButton
                  disabled={isDeletingReport}
                  onClick={() => setDeleteDialogData(null)}
                >
                  CANCEL
                </ArgosButton>
                <ArgosLoadingButton
                  disabled={deleteDialogData == null}
                  isLoading={isDeletingReport}
                  onClick={() => {
                    deleteDevelopmentStage()
                  }}
                >
                  DELETE
                </ArgosLoadingButton>
              </ArgosFlexbox>
            </BoxWithCenteredContent>
          </ArgosDialog>

        </ArgosContextMenu>
      }
    </>
  )
}

export default ContextMenu